<template>
    <div class="main-page">
        <transition name="fade-page" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
export default {

}
</script>



// WEBPACK FOOTER //
// main-page.vue?486f5f51